import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import routes from "./routes";
import withTracker from "./withTracker";
import { initAxiosAuth } from "./api";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/shards-dashboards.1.1.0.css";
import AdminCreator from "./views/admin.min.js";
import AdminWrapper from "./components/AdminWrapper";
import "react-toastify/dist/ReactToastify.css";
import Errors from "./views/Errors";
import ErrorBoundary from "./Errorboundary";
import Processing from "./processing";
import { DotLoader } from "react-spinners"; // Importing DotLoader

const Admin = AdminCreator(
  process.env.REACT_APP_API_URL.substring(
    0,
    process.env.REACT_APP_API_URL.length - 1
  ),
  "nt-theme"
);

// External redirect routes
const ExternalRedirectRoute = ({ externalUrl }) => {
  React.useEffect(() => {
    window.location = externalUrl;
  }, [externalUrl]);
  
  return null; // Component won't render as redirect happens immediately
};

const FallbackLoader = () => (
  <div className="mainLoaderBlock">
    <DotLoader color="#36d7b7" />
    <label style={{ marginTop: 30 }}>Loading your content...</label>
  </div>
);

initAxiosAuth();

// Helper component to check if we should render admin
const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  // Handle admin authentication
  if (isAdminRoute) {
    let userDetails = JSON.parse(localStorage.getItem("user"));
    const token = JSON.parse(localStorage.getItem("session"));
    
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    if (userDetails && userDetails.userRoleId === 2) {
      return <Navigate to="/errors" replace />;
    }
    
    // Render admin component with its own router
    Admin.setToken(token);
    return <AdminWrapper AdminComponent={Admin.AdminComponent} match={{ url: "/admin" }} />;
  }

  // Render normal routes
  return (
    <Suspense fallback={<FallbackLoader />}>
      <Routes>
        {routes.map((route, index) => {
          // Wrap component with tracker HOC, then render inside layout
          const TrackedComponent = withTracker(route.component);
          const element = (
            <Suspense fallback={<FallbackLoader />}>
              <route.layout>
                <TrackedComponent />
              </route.layout>
            </Suspense>
          );

          return (
            <Route
              key={index}
              path={route.path}
              element={element}
            />
          );
        })}

        {/* External redirect routes */}
        <Route
          path="/tone-Vays"
          element={<ExternalRedirectRoute externalUrl="https://bitcoin.live/blogs/public?aid=104" />}
        />
        <Route
          path="/dean"
          element={<ExternalRedirectRoute externalUrl="https://bitcoin.live?aid=108" />}
        />
        <Route
          path="/peterbrandt"
          element={<ExternalRedirectRoute externalUrl="https://admin_4981.gr8.com/bitlive_peterbrandt" />}
        />
        <Route
          path="/bobloukas"
          element={<ExternalRedirectRoute externalUrl="https://admin_e261.gr8.com/bitlive_bobloukas" />}
        />
        <Route
          path="/bigcheds"
          element={<ExternalRedirectRoute externalUrl="https://admin_c50e.gr8.com/bitlive_bigcheds" />}
        />
        <Route
          path="/haejinlee"
          element={<ExternalRedirectRoute externalUrl="https://chrish_eb79.gr8.com/bitlive_haejinlee" />}
        />
        <Route
          path="/Consensus"
          element={<ExternalRedirectRoute externalUrl="https://chrish_76b9.gr8.com" />}
        />
        <Route
          path="/consensus"
          element={<ExternalRedirectRoute externalUrl="https://chrish_76b9.gr8.com" />}
        />

        {/* Processing route */}
        <Route path="/processing" element={<Processing />} />

        {/* Catch-all 404 route - must be last */}
        <Route path="*" element={<Errors />} />
      </Routes>
    </Suspense>
  );
};

class App extends React.Component {
  render() {
    return (
      <ErrorBoundary>
        <Router basename={process.env.REACT_APP_BASENAME || ""}>
          <AppContent />
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;
